import { Dispatch, SetStateAction } from "react";
import { calculateAge } from "../../../../utilis/methods/dateMethods";
import {
  EmergencyContactFormType,
  EmergencyContactModel,
  extractPatientData,
  PatientRegistrationFormType,
} from "../type/RegistrationModel";
import usePopup from "../../../../hooks/usePopup";
import { clinicId } from "../../../../constants";
import {
  PatientRegistrationDataType,
  SaveResponseType,
} from "../type/RegistrationDataType";
import { useMutation } from "react-query";
import { registerPatient } from "../registrationServices";
import useAuthentication from "@hooks/useAuthentication";
const useSaveRegistration = (
  saveLoadingState: Dispatch<SetStateAction<boolean>>,
  onSuccess?: (data: SaveResponseType) => void
) => {
  const { showSnackbar } = usePopup();
  const {user} = useAuthentication()
  const { mutate: saveData } = useMutation(registerPatient, {
    onSuccess: (result) => {
      saveLoadingState(false);
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          variant: "success",
          open: true,
          duration: 3000,
        });
        if (onSuccess) {
          onSuccess(result?.response);
        }
      } else {
        showSnackbar({
          message: result.responseMessage,
          variant: "warning",
          open: true,
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      saveLoadingState(false);
      showSnackbar({
        message: e.response.data.responseMessage,
        variant: "error",
        open: true,
        duration: 3000,
      });
    },
  });
  const handleSave = (
    value: PatientRegistrationFormType,
    patientData: PatientRegistrationDataType,
    emergencyContact: EmergencyContactFormType[],
    bookingId: number | null | undefined,
    destination: string
  ) => {
    saveLoadingState(true);
    let errorMessage: string = "";
    let eContact: EmergencyContactModel[] | null = [];

    const data = extractPatientData(
      {
        ...value,
        calcuatedAge: calculateAge(value.dob),
      },
      patientData
    );
    if (Boolean(emergencyContact?.length > 0)) {
      let nullCount = 0;
      let count = "";
      let obj: EmergencyContactModel | null = null;
      emergencyContact.forEach((con, index) => {
        nullCount = 0;
        obj = {
          address1: con.address || null,
          address2: con.address || null,
          firstName: con.givenName,
          addressTypeId: con?.addressType?.id || null,
          clinicId,
          contactTypeId: con?.contactType?.contactrollId || null,
          createdId: Number(user?.userId),
          ecNo: index + 1,
          emergencyContactId: con?.emergencyContactId || null,
          streetAddress: con?.streetAddress || null,
          familyName: con?.familyName || null,
          hl7MsgStatus: 0,
          ip: "",
          mobileNo: con.mobileNumber,
          patientMasterId: data.patientMasterId,
          relationshipId: con?.relation?.relationId || null,
          status: 1,
        };

        for (let key in con) {
          if (!Boolean(con[key as keyof typeof con]) && key != "emergencyContactId") {
            nullCount += 1;
          }
        }

          if (nullCount < 8 && nullCount > 0) {
            console.log("inside condition 1",con,`nullCount = ${nullCount}`)
            count =
              count +
              `${index + 1} ${index == emergencyContact.length - 1 ? "" : ", "}`;
          } else {
            nullCount == 0 && (eContact?.push(obj));
          }
      });
      if (count.length > 0) {
        errorMessage = `Please fill all fields in emergency contact ${count}`;
      }
    }
    if (errorMessage.length > 0) {
      saveLoadingState(false);
      showSnackbar({
        message: errorMessage,
        variant: "warning",
        open: true,
        duration: 3000,
      });
    } else {
      // const destination = "Registered"
      saveData({ ...data, emergencyContactDto: eContact, bookingId, destination, documents: value.documents });
      // saveLoadingState(false)
      // console.log('emergencyContact----->',emergencyContact)
      // console.log("registration called-->",{...data,emergencyContact:eContact,bookingId});
    }
  };
  return handleSave;
};

export default useSaveRegistration;
